<router-outlet></router-outlet>

<ng-progress></ng-progress>
<nucbot-widget class="nucbot-floating" [nucbotAuthToken]="nucbotAuthToken" *ngIf="nucbotAuthToken !== undefined"></nucbot-widget>
